import React from 'react';
import { NavLink } from 'react-router-dom';
import '../css/SideBar.css';

const Sidebar = () => {
  return (
    <div className="sidebar">
      {/* <NavLink to="/home" className="menu-item" activeClassName="active">
        <img src={require('../assets/images/dashboard.png')} alt="Dashboard" className="menu-icon" />
      </NavLink> */}
      <NavLink to="/agentSelection" className="menu-item" activeClassName="active">
        <img src={require('../assets/images/agent.png')} alt="Agent" className="menu-icon" />
      </NavLink>
      {/* <NavLink to="/settings" className="menu-item" activeClassName="active">
        <img src={require('../assets/images/Settings.png')} alt="Settings" className="menu-icon" />
      </NavLink> */}
    </div>
  );
};

export default Sidebar;
